<div class="settingsLinkDialog">
    <sync-dialog [config]="{
    title: 'Advanced link settings',
    subTitle: fileName,
    isClosable: true,
    closeIcon:'arrow-left',
    onCloseIcon: onBack,
    actionButton: 'Save',
    cancelButton: 'Back',
    onActionClick: onSubmit,
    onCancelClick: onBack,
    isButtonLoading: isButtonLoading,
}" [open]="showSettingsLinkDialog" [isFullScreen]="false" [onClose]="closeSettingsLinkDialog">
            <div class="link-settings-container">
                <sync-alert *ngIf="!isPro" class="purge-alert" type="promo" [showLeadIcon]="true" leadIcon="star-badge"
                title="Upgrade to get these great link features:"
                description="{{linkFeatures}}"
                [showActions]="true"
                [showPrimaryAction]="true"
                [showSecondaryAction]="false"
                [primaryButtonConfig]="{ label: 'Upgrade', onClick: redirectToUpgrade }"
                [showCloseButton]="false"></sync-alert>

                <div class="label">
                    <sync-section-header [header]="'Label name'"
                        [description]="'Customize how your file or folder name appears when sharing a link. Viewers will see the real name when the link is opened.'"
                        [level]="'subtitle'">
                    </sync-section-header>
                    <sync-text-field
                        [label]="'Label name'"
                        [(value)]="labelName">
                    </sync-text-field>
                </div>

                <div class="notifications" *ngIf="isPro">
                    <sync-section-header [header]="'Notifications'"
                        [description]="'Choose when to receive email notifications about this link'"
                        [level]="'subtitle'">
                    </sync-section-header>
                    <div class="checkbox">
                        <sync-checkbox [label]="'New comments'" [checked]="newCommentsNotification ? true : false" [indeterminate]="false"
                            [disabled]="false" [onChange]="newCommentsNotificationChange"></sync-checkbox>
                        <sync-checkbox [label]="(fileType === 'dir')?'New downloads and uploads':'New downloads'" [checked]="newDownloadsNotification ? true : false" [indeterminate]="false"
                            [disabled]="false" [onChange]="newDownloadsNotificationChange"></sync-checkbox>
                    </div>
                </div>
                <sync-divider *ngIf="isPro" [text]="'Content'" [size]="'default'"></sync-divider>
                <div class="comments" *ngIf="hasComment && (hasBetaAccess || !isAppLink)">
                    <sync-section-header [header]="'Comments'" [description]="commentsEnabled ? 'Allow users to comments' : 'Choose who is allowed to comment'"
                        [level]="'subtitle'" [showActions]="true" [showSwitch]="true" 
                        [switchConfig]="{size: 'large', disabled: false, label: '', labelPosition: 'after', required: true, ariaDescribedby: '', ariaLabel: '', ariaLabelledby: '', name: '', checked: link.allow_comment !==0 ? true : false, onChange:toggleComments}">
                    </sync-section-header>
                    <div class="allow-comments" *ngIf="commentsEnabled">
                        <sync-radio-button-group class="radio-buttons" [radioButtonItems]="allowCommentsOptions" [changeRadioButtonValue]="allowCommentsChange" />
                    </div>
                </div>
                <sync-divider *ngIf="isPro && fileType !== 'dir'" [text]="'Content'" [size]="'default'"></sync-divider>
                <div class="download-limit" *ngIf="isPro && fileType !== 'dir'">
                    <sync-section-header [header]="'Download limit'"
                        [description]="'Set a limit for how many times the file can be downloaded'" [level]="'subtitle'"
                        [showActions]="true" [showSwitch]="true"
                        [switchConfig]="{size: 'large', disabled: false, label: '', labelPosition: 'after', required: true, ariaDescribedby: '', ariaLabel: '', ariaLabelledby: '', name: '', checked: limitEnabled, onChange:toggleDownloadLimit}">
                    </sync-section-header>
                    <sync-text-field class="Limit" *ngIf="limitEnabled" inputType="number" [label]="'Limit'"
                        [(value)]="downloadLimit" [inputChange]="downloadLimitChange" [errorMessage]="errorMessage" [minValue]="0"></sync-text-field>
                </div>
                <sync-divider [text]="'Content'" [size]="'default'"></sync-divider>
                <div class="privacy">
                    <sync-section-header [header]="'Enhanced privacy'"
                        [description]="'Enables end-to-end encryption on shared links'" [level]="'subtitle'"
                        [showActions]="true" [showSwitch]="true" 
                        [switchConfig]="{size: 'large', disabled: false, label: '', labelPosition: 'after', required: true, ariaDescribedby: '', ariaLabel: '', ariaLabelledby: '', name: '', checked: link.compat === 0 ? true : false, onChange:togglePrivacy}">
                    </sync-section-header>
                </div>
                <div class="delete">
                    <div class="delete-section">
                        <sync-section-header class="delete-section-header" [header]="'Delete link'"
                            [description]="'Remove the link to this ' + (fileType === 'dir' ? 'folder.' : 'file.')" [level]="'subtitle'" [showActions]="true"
                            [showButton]="true"
                            [buttonConfig]="{label: 'Delete', type: 'outlined', color: 'critical', size:'small', leadAdornment:false, onClick: onDeleteLink.bind(this)}">
                        </sync-section-header>
                    </div>
                </div>
            </div>
    </sync-dialog>
</div>